/** core Modules */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/** npm Modules */
import { NgxPaginationModule } from "ngx-pagination";

/** Directives */

/** pipes */
import { CurrencyPipe, DatePipe, DecimalPipe} from "@angular/common";
import { OrderByPipeModule } from "@core/pipes/order-by";
/** Services */
/** custom Modules */
import { CardModule } from "@core/components/card";
import { UtilsPipeModule } from '@core/pipes/utils-pipe';
import { TextTemplateModule } from '@core/components/text-template';
import { SteppIndicatorModule } from '@core/components/stepp-indicator';
import { DownloadButtonsModule } from '@core/components/download-buttons';
import { UtilitiesDirectiveModule } from '@core/directives/utilities-directive';
import { BxBaseTemplateModule } from 'app/layout/components-common/section-base-template/section-base-template.module';

/** Mat Modules */
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SectionButtonsModule } from '@core/components/section-buttons';
import { MatCardModule } from "@angular/material/card";

const coreModules = [CommonModule, FormsModule, ReactiveFormsModule,];
const matModules = [MatFormFieldModule, MatIconModule, MatInputModule, MatButtonModule, MatCardModule];
const npmModules = [NgxPaginationModule];
const pipeModules = [CurrencyPipe, DatePipe, DecimalPipe, OrderByPipeModule];
const moduleComponents = [];
const customModules = [BxBaseTemplateModule, CardModule, DownloadButtonsModule, SectionButtonsModule, UtilsPipeModule, SteppIndicatorModule, UtilitiesDirectiveModule, TextTemplateModule];
const pipeProviders = [];
const sharedServices = [];
@NgModule({
  imports: [...coreModules, ...customModules, ...npmModules, ...matModules, ...pipeModules],
  exports: [...coreModules, ...customModules, ...npmModules, ...matModules, ...pipeModules]
})

export class SharedModule { }
